import Skeleton from '@/components/Skeleton';

function ColumnSkeleton() {
  return (
    <div className="flex flex-col rounded-md border border-gray-200 bg-gray-50 dark:border-gray-700 dark:bg-gray-800/50">
      {/* Column header */}
      <div className="flex items-center justify-between px-3 py-3">
        <div className="flex items-center gap-2">
          <Skeleton className="h-2.5 w-2.5 rounded-full" />
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-5 w-6 rounded-full" />
        </div>
      </div>

      {/* Add item button placeholder */}
      <div className="px-2 pb-1">
        <Skeleton className="h-8 w-full rounded-lg" />
      </div>

      {/* Card placeholders */}
      <div className="flex-1 space-y-2 px-2 pb-2">
        {Array.from({ length: 3 }).map((_, i) => (
          <div
            key={i}
            className="rounded-md border border-gray-100 bg-white p-3 dark:border-gray-700 dark:bg-gray-800"
          >
            <Skeleton className="mb-2 h-4 w-3/4" />
            <Skeleton className="mb-3 h-3 w-full" />
            <div className="flex gap-1.5">
              <Skeleton className="h-5 w-14 rounded-full" />
              <Skeleton className="h-5 w-10 rounded-full" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function BoardSkeleton() {
  return (
    <div className="hidden md:grid md:grid-cols-5 md:gap-3 lg:gap-4">
      {Array.from({ length: 5 }).map((_, i) => (
        <ColumnSkeleton key={i} />
      ))}
    </div>
  );
}
